const FollowersColumn = () => {
    return (
      <div className="followers-column">
          <h1>FollowersColumn</h1>
      </div>
    );
  }
  
  export default FollowersColumn;
  